import { 
    yellow,
    red,
    blue,
    axisName,
    pageBg
} from './color'

export var get1 = function(){
  return { 
    $axisIndex: 0,
    shadow: {
      show: false,
      style: {
        fill: 'rgba(5,83,161,0.1)'
      }
    },
    line: {
      show: true,
      style:{
        lineDash: [4, 2],
        stroke: '#3D76B8'
      }
    },
    label: {
      show: true,
      gap: 5,
      style: {
        fill: '#fff',
        textBackgroundColor: 'rgba(0,150,255,0.6)',
        textBorderColor: blue,
        textBorderWidth: 1,
        fontSize: 10
      }
    }
  }
}